import { Spinner } from "flowbite-react";
import { useTranslation } from "@repo/core";

interface LoadingMonthlyReturnsProps {
  className?: string;
}

export const LoadingMonthlyReturns = ({ className = "" }: LoadingMonthlyReturnsProps) => {
  const { tStrategy } = useTranslation();

  return (
    <div className={`space-y-6 ${className}`}>
      {/* Distribution Loading */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          {tStrategy("monthlyReturns")}
        </h2>
        <hr className="border-gray-200 mb-6" />
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <Spinner size="xl" />
            <p className="mt-4 text-gray-600">{tStrategy("monthlyReturnsLoading")}</p>
          </div>
        </div>
      </div>

      {/* Heatmap Loading */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          {tStrategy("monthlyReturnsHeatmapTitle")}
        </h2>
        <hr className="border-gray-200 mb-6" />
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <Spinner size="xl" />
            <p className="mt-4 text-gray-600">{tStrategy("monthlyReturnsLoading")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMonthlyReturns;
